import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import useLogout from '@hooks/useLogout';

const ErrorMessage = ({ message }) => {
  const { logout } = useLogout();

  return (
    <Wrapper>
      {message}
      <br />
      <span>
        Feel free to <FakeLink onClick={logout}>try again</FakeLink>.
      </span>
    </Wrapper>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
`;

// Uses the default blue color for chrome
const FakeLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: inline;
  padding: 0;
  color: #36449d;
  text-decoration: underline;
`;

export default ErrorMessage;
